// extracted by mini-css-extract-plugin
module.exports = {"popoverLargeContent":"PlanType__popoverLargeContent___KUCG_"};